import { Bar } from "react-chartjs-2";
import { Chart, registerables } from "chart.js";

Chart.register(...registerables);
const Barchart = ({data}) => {
  return (
    <Bar
            data={data}
            options={{
              responsive: true,
              plugins: {
                legend: {
                  display: false
                }
              }, 
              scales: {
                x: {
                  grid: {
                    display: false, 
                    tickBorderDash: [8, 4]
                  }
                }
              }
            }}
          />
  )
}

export default Barchart